import { useState, useEffect } from 'react';
import { addToastListener, hideToast, showToast } from '../utils/toast';

/**
 * Hook para usar toasts
 * @returns {Object} { toasts, showToast, hideToast, clearToasts }
 */
export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const unsubscribe = addToastListener(setToasts);
    return unsubscribe;
  }, []);

  const handleHide = (id) => {
    hideToast(id);
  };

  return {
    toasts,
    showToast,
    hideToast: handleHide
  };
};
